export default __webpack_public_path__ + "static/media/Tabs.6f5885c8.svg";